module.exports = __webpack_public_path__ + "static/media/Bytt-tutorial-6.b743efa8.mp3";